// Filter column names for the getAgentConversations list (backed by the
// agentConversation.api.go filter registry). AgentConversationTable's
// column ids double as the server sort/filter column name, so these are
// shared with anything that needs to build a filter for the same query
// (e.g. a future "conversations for this team" deep link).
export const USER_EMAIL_COLUMN = "UserEmail"
export const TENANT_NAME_COLUMN = "TenantName"

// Surface values stored on agent.Conversations.Surface (see the CHECK
// constraint on that column): which chat the conversation happened in.
export const SURFACE_LABELS: Record<string, string> = {
  agent: "Agent",
  layerchat: "Layer chat",
  filterchat: "Filter chat",
}

// Runtime values stored on agent.Conversations.Runtime (see the CHECK
// constraint on that column) — kept here instead of the table so the
// filter's option list and any future badge share one source.
export const RUNTIME_LABELS: Record<string, string> = {
  messages: "Messages API",
  managed: "Managed Agents",
}
